<!-- Página de error 404, se muestra cuando el usuario intenta acceder a una ruta que no existe -->
<h1>404</h1>
<h2>Página no encontrada</h2>
<p class="bottom-spacing">La página a la que intenta acceder no existe</p>
<div class="text-center">
  <button mat-raised-button routerLink="/">Volver al inicio</button>
</div>
